import * as PIXI from "pixi.js";
import Layers from "../../layers/Layers";
import LineFactory from "./LineFactory";
import { Coord, LineConfig } from "../../types/Interface";
import { ArrowCap } from "../../types/Enum";
import { LINE_CONFIG } from "../../types/Config";
import { getCoordsForArrowCaps } from "./helpers/DrawingHelpers";


export default class Line extends PIXI.Graphics {
  private Layers = Layers.getInstance();
  private LineFactory!: LineFactory;
  private Config = { ...LINE_CONFIG };
  private isVisibleEqualSymbol = false;
  public coordStart: Coord = { x: 0, y: 0 };
  public coordEnd: Coord = { x: 0, y: 0 };

  constructor(Config?: LineConfig) {
    super();
    Config && Object.assign(this.Config, Config);
    this.LineFactory = new LineFactory(this.Config.width, this.Config.color)
    this.addToLayer();
  }
  private addToLayer = () => this.Layers.Middle.addChild(this);

  setLineColor(color: number) {
    this.Config.color = color;
    this.LineFactory.setLineColor(color);
  }
  setVisibleOfEqualSymbol = (v: boolean) => {
    this.isVisibleEqualSymbol = v;
    this.draw(this.coordStart, this.coordEnd);
  }

  draw(coordStart: Coord, coordEnd: Coord) {
    this.coordStart = coordStart;
    this.coordEnd = coordEnd;
    if (this.Config.arrowCap !== ArrowCap.None) {
      const coords = getCoordsForArrowCaps(coordStart, coordEnd);
      if (this.Config.arrowCap === ArrowCap.Both) {
        this.coordStart = coords.coordStart;
        this.coordEnd = coords.coordEnd;
      } else if (this.Config.arrowCap === ArrowCap.Start) {
        this.coordStart = coords.coordStart
      } else if (this.Config.arrowCap === ArrowCap.End) {
        this.coordEnd = coords.coordEnd;
      }
    }

    this.LineFactory.drawLines(this, this.coordStart, this.coordEnd, this.Config.isDashed);
    this.LineFactory.drawArrowCaps(this, this.coordStart, this.coordEnd, this.Config.arrowCap);

    if (this.isVisibleEqualSymbol && this.Config.isEqualSymbol) {
      this.LineFactory.drawEqualSymbol(this.Config.equalSymbol, this, this.coordStart, this.coordEnd);
    }
  }
}


